export const BANK_PAYMENT_METHODS = ["Postal", "Wire Transfer", "Credit Card"];

export const CURRENCIES = ["CHF", "EUR", "GBP", "USD"];
export const CURRENCY_SYMBOLS = { CHF: "CHF", EUR: "€", GBP: "£", USD: "$" };

export const monthOrder = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };